import {GeneratedType} from "@shareledgerjs/signing";

export function createAuthTypes(): ReadonlyArray<[string, GeneratedType]> {
  return [];
}
